import { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useAlert } from 'react-alert'

import { ConstrutosCustomModel } from '../../../../domain/models'
import {
  fetchModelConstrutos,
  resetConstrutos,
  saveConstrutoModel,
  updateConstrutoModel
} from '../../../../main/usecases'

import { formatDate, goToUrl } from '../../../utils'
import { useModalBox, useOnChangeDetect } from '../../../contexts'
import {
  Button,
  SubHeader,
  EditorCard,
  Loading,
  ServicesHeader
} from '../../../components'

import { IconSaveSvg, IconReturnSvg } from '../../../assets/icons/svgComponents'

import * as S from './styles'

const Construto = () => {
  const [construto, setConstruto] = useState<ConstrutosCustomModel[]>([])
  const [construtoText, setConstrutoText] = useState('')
  const [htmlList, setHtmlList] = useState<any>({})
  const alert = useAlert()
  const location: any = useLocation()
  const history = useHistory()
  const { modalBox, modalClose } = useModalBox()
  const { refresh, setRefresh } = useOnChangeDetect()

  const handleOpenResetModal = () => {
    modalBox(
      <div className="delete-modal">
        <p className="attention-label">
          ATENÇÃO: Todas as edições serão perdidas
        </p>
        <p>Deseja realmente resetar o construto?</p>
        <div>
          <Button
            hasredButton
            onClick={() =>
              handleResetConstruto(
                location.state.cdTypeToService || null,
                location.state.cdConstruto || null
              )
            }
          >
            Sim
          </Button>
          <Button hasSecodaryButton onClick={modalClose}>
            Não
          </Button>
        </div>
      </div>,
      'Resetar Construto',
      '32%'
    )
  }

  const handleResetConstruto = async (
    cdTypeToService: number | null,
    cdConstruto: number | null
  ) => {
    try {
      if (cdTypeToService && cdConstruto) {
        const responseToReset = await resetConstrutos({
          cdTypeToService: cdTypeToService,
          cdConstruto: cdConstruto
        }).load()
        modalClose(true)
        alert.show('Construto resetado com sucesso', {
          type: 'success',
          timeout: 4000
        })
        setConstruto(responseToReset)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao resetar um Construto', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    if (construto) {
      const texts = construto?.map((item) => item?.texto)
      setHtmlList(texts)
    }
  }, [construto, refresh])

  useEffect(() => {
    ;(async () => {
      try {
        if (!location?.state) goToUrl(history, '/construtos')

        const data = await fetchModelConstrutos({
          cdConstruto: location?.state?.cdConstruto,
          cdTypeToService: location?.state?.cdTypeToService
        }).load()
        setConstruto(data)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [
    history,
    location?.state,
    location?.state?.construto,
    location?.state?.cdTypeToService
  ])

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault()

    const body = construto?.map((item, index) => {
      return {
        ...(item?.modeloAdm === false && {
          cdConstrutoResultado: item?.cdConstrutoResultado
        }),
        classificacao: item.classificacao,
        texto: htmlList[index] || construtoText
      }
    })

    try {
      if (construto && construto[0]?.modeloAdm) {
        const responseToPost = await saveConstrutoModel({
          cdConstruto: location.state.cdConstruto,
          cdTypeToService: location.state.cdTypeToService
        }).post(body)
        alert.show('Salvo com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setConstruto(responseToPost)
        setRefresh((prev: any) => !prev)
      } else {
        const responseToPut = await updateConstrutoModel().update(body)
        alert.show('Atualizado com sucesso!', {
          type: 'success',
          timeout: 4000
        })
        setConstruto(responseToPut)
        setRefresh((prev: any) => !prev)
      }
    } catch (error) {
      alert.show('Error ao salvar/atualizar', {
        type: 'error',
        timeout: 4000
      })
      console.error(error)
    }
  }

  if (!document) return <Loading />

  return (
    <S.Wrapper>
      <SubHeader page="Voltar" link={`/construtos`} />
      <S.CardContainer>
        <ServicesHeader
          onClick={onSubmit}
          hasReset
          onReset={handleOpenResetModal}
          title={
            `${location?.state?.construtoTitle} | ${location?.state?.serviceTitle}` ||
            ''
          }
        />
        {construto.map((item, index) => (
          <EditorCard
            data={item && item?.texto}
            setData={setConstrutoText}
            title={
              item && `${item.classificacao} | ${item?.construto.construto}`
            }
            onChangeContentToEditor={(html) => {
              setConstrutoText((prev: any) => ({
                ...prev,
                [index]: html
              }))
              setHtmlList((prev: any) => ({
                ...prev,
                [index]: html
              }))
            }}
          />
        ))}
        {construto.length ? (
          <S.ButtonsContainer>
            <Button
              initialIcon={<IconSaveSvg />}
              className="button-save"
              onClick={onSubmit}
            >
              Salvar
            </Button>
            <Button
              initialIcon={<IconReturnSvg />}
              hasSecodaryButton
              className="button-return-to-list"
            >
              <Link to={`/construtos`}>Retornar à listagem</Link>
            </Button>

            {construto[0]?.dataUltimaModificacao && (
              <p>
                Data da última atualização:{' '}
                {formatDate(
                  construto[0]?.dataUltimaModificacao || '2022-05-05'
                )}
              </p>
            )}
          </S.ButtonsContainer>
        ) : (
          ''
        )}
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default Construto
